import { setFontFamilies, type FontFamily } from '@bynder-studio/structured-text';
import { Dimension } from '../Models/Shared/Dimension';
import { ImageModel } from '../Models/Models/ImageModel';
import { MultiPageImageModel } from '../Models/Models/MultiPageImageModel';
import { WebSpecificationParser } from './WebSpecificationParser';
import type { Template, TemplatePage } from '../Renderers/BaseRenderer/IBaseRenderer';
import { ElementTypes } from '../Enums/ElementTypes';
import { VisualElement } from '../types';

export class ImageWebSpecificationParser extends WebSpecificationParser {
    readonly ELEMENTS_TYPES_TO_PARSE = [ElementTypes.IMAGE, ElementTypes.TEXT, ElementTypes.SHAPE, ElementTypes.GROUP];

    // TODO: Seems useles, delete later
    parse = (imageSpecification: Template, pageIndex: number, fontFamilies: FontFamily[]): ImageModel => {
        setFontFamilies(fontFamilies);
        const testSpec = imageSpecification.pages[0];

        return new ImageModel()
            .setElements(this.parseElements(testSpec, fontFamilies))
            .setBackgroundColor(this.parseBackgroundColor(testSpec))
            .setDimensions(this.parseDimensions(imageSpecification, pageIndex));
    };

    parseMultiPage = (imageSpecification: Template, fontFamilies: FontFamily[]): MultiPageImageModel => {
        const pages = this.parsePages(imageSpecification);

        return new MultiPageImageModel()
            .setModels(
                pages.map((page: TemplatePage) => {
                    const { width, height } = page;
                    const dimension = new Dimension(width, height);

                    return new ImageModel()
                        .setDimensions(dimension)
                        .setElements(this.parseElements(page, fontFamilies))
                        .setBackgroundColor(this.parseBackgroundColor(page));
                }),
            )
            .setModelsMetaData(
                pages.map(({ id, name, displayOrder, format }: TemplatePage) => ({
                    id,
                    name,
                    displayOrder,
                    format,
                })),
            );
    };

    parseElements(
        { elements: rawElements }: Pick<TemplatePage, 'elements'>,
        fontFamilies: FontFamily[],
    ): VisualElement[] {
        return super.parseElementByType<VisualElement>(
            { elements: rawElements },
            fontFamilies,
            this.ELEMENTS_TYPES_TO_PARSE,
        );
    }
}
